import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Permissions } from '../../app/services/Permissions';
import ErrorContent from '../../components/error/ErrorContent';
import HrbTranslate from '../../components/language/HrbTranslate';
import Section from '../../components/layout/Section';
import HelpLink from '../../components/library/common/HelpLink';
import './AssociatesPage.scss';
import AssociatesPageHeader from './components/AssociatesPageHeader';
import AssociatesSelector from './components/AssociatesSelector';

const AssociatesPage = () => {

    const hasPermission = useSelector(state => (state.accountData.permissions || []).includes(Permissions.MANAGE_ASSOCIATES)
                                            || (state.accountData.permissions || []).includes(Permissions.MANAGE_ALL_ASSOCIATES))
    const firstName = useSelector(state => state.accountData.firstName || '')
    const { employeeId } = useParams('employeeId');
    localStorage.setItem('pageSelections', JSON.stringify([]));
    localStorage.setItem('reassignTicketIds', JSON.stringify([]));

    return (
        <div className="content-grid queue" >
            <Section sectionId='section-associates-summary' className='white'>
                {!hasPermission &&
                    <ErrorContent errorDetailKey='Errors.NotAllowedDetail' errorTitleKey='Errors.NotAllowedTitle' />
                }
                {hasPermission &&
                    <AssociatesPageHeader firstName={firstName} />
                }
            </Section>
            {hasPermission &&
                <Section sectionId='section-associates' className='light-functional-grey'>
                    <div className="columns">
                        <div className='column is-7 is-offset-1'>
                            <h3><HrbTranslate text='AssociatesPage.Labels.PageTitle' /></h3>
                            <p className='p1 mt-4'>
                                <HrbTranslate text='AssociatesPage.Labels.PageDescription' />
                            </p>
                        </div>
                        <div className='column is-1' />
                        <div className='column is-2'>
                            <HelpLink helpKey='0ProSupport/VDOPro/DMDoC_ManageAutoAssignAndOffices.htm' />
                        </div>
                    </div>
                    <AssociatesSelector employeeId={employeeId} />
                </Section>
            }
        </div>
    );
}

AssociatesPage.whyDidYouRender = false;

export default AssociatesPage